import { render, staticRenderFns } from "./TabChattingRoom.vue?vue&type=template&id=85aee1f0&scoped=true&"
import script from "./TabChattingRoom.vue?vue&type=script&lang=js&"
export * from "./TabChattingRoom.vue?vue&type=script&lang=js&"
import style0 from "./TabChattingRoom.vue?vue&type=style&index=0&id=85aee1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aee1f0",
  null
  
)

export default component.exports